import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { justForSideEffectWithPayload } from 'src/infrastructure/saga.helpers'
import { GetInvoiceParams, DanfeState } from './danfeTypes'

const getInvoice = justForSideEffectWithPayload<GetInvoiceParams>()

const initialState: DanfeState = {
  invoiceHtml: '',
  loading: false,
}

const setLoading = (
  state: DanfeState,
  { payload }: PayloadAction<boolean>,
): DanfeState => ({
  ...state,
  loading: payload,
})

const setInvoiceHtml = (
  state: DanfeState,
  { payload }: PayloadAction<string>,
): DanfeState => ({
  ...state,
  invoiceHtml: payload,
})

const slice = createSlice({
  name: 'InvoiceModal',
  initialState,
  reducers: {
    setLoading,
    setInvoiceHtml,
    getInvoice,
  },
})

export default slice.reducer

export const { actions } = slice
